var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[_c('Normaltop',{attrs:{"url":_vm.qiniuUrl,"title":"认证体系","en":"Certification System"}}),_c('div',{staticClass:"news-cont"},[_c('normalcert',{attrs:{"url":_vm.url,"info":_vm.info}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }